import { environment } from '@environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { LegalCopyFetchRequest, LegalCopyFetchResponse } from './legal-copy.types';

@Injectable({
  providedIn: 'root',
})
export class LegalCopyService {
  private http = inject(HttpClient);

  fetchLegalCopy(payload: LegalCopyFetchRequest): Observable<LegalCopyFetchResponse | any> {
    const { id, contentTypeId } = payload;
    return this.http.get<LegalCopyFetchResponse>(`${environment.endpointApiOne}/v1/content/${contentTypeId}/${id}`);
  }
}
